var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',_vm._b({attrs:{"lazy-validation":""},on:{"input":function($event){return _vm.verifyEmailExists()}},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}},'v-text-field',_vm.currentProperties(),false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }